/*
 * @LastEditTime: 2020-06-17 10:58:21
 * @LastEditors: jinxiaojian
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import iconEmpty from './images/empty.svg';

export default function NoResult(props) {
  const { desc, className, mini, style, icon = iconEmpty } = props;
  const classes = classNames('no-result', className, {
    mini
  });
  return (
    <div role="no-result" className={classes} style={style}>
      <Icon className="no-result-icon" link={icon} />
      <p>{desc}</p>
    </div>
  );
}
NoResult.propTypes = {
  /** 无数据时的描述 */
  desc: PropTypes.string,
  /** 是否迷你 */
  mini: PropTypes.bool
};
NoResult.defaultProps = {
  desc: '暂无数据',
  mini: false
};
